import * as React from 'react';
import { SurfaceContext } from '../../../types/contexts';
import { createSurfaceContextProvider } from '../../common/surface-context-provider';

export const ConfigureConnectionDialogContext = React.createContext<SurfaceContext>({ isOpen: false });
export const ConfigureConnectionDialogContextProvider = createSurfaceContextProvider(ConfigureConnectionDialogContext);
